import POSTS_DOMAIN from './domain'
import POSTS_KEY from './key'

const POSTS_PATH = {
  ALL: `${POSTS_DOMAIN}.${POSTS_KEY.ALL}`,
  ALL_DATA: `${POSTS_DOMAIN}.${POSTS_KEY.ALL}.data`,
  ARTICLES: `${POSTS_DOMAIN}.${POSTS_KEY.ARTICLES}`,
  ARTICLES_DATA: `${POSTS_DOMAIN}.${POSTS_KEY.ARTICLES}.data`,
  WORKOUTS_LOGGED: `${POSTS_DOMAIN}.${POSTS_KEY.WORKOUTS_LOGGED}`,
  WORKOUTS_LOGGED_DATA: `${POSTS_DOMAIN}.${POSTS_KEY.WORKOUTS_LOGGED}.data`,
  PLANS_LOGGED: `${POSTS_DOMAIN}.${POSTS_KEY.PLANS_LOGGED}`,
  PLANS_LOGGED_DATA: `${POSTS_DOMAIN}.${POSTS_KEY.PLANS_LOGGED}.data`,
  CURRENT: `${POSTS_DOMAIN}.${POSTS_KEY.CURRENT}`,
  DATA: `${POSTS_DOMAIN}.${POSTS_KEY.DATA}`
}

export default POSTS_PATH
